import { editorColorSpecFromCss } from '@messenger/lotus'
import type { EditorCharacterStyleLayer } from '@messenger/lotus'
import type { EditorCharacterStylingInput } from '@messenger/lotus/row-store'

const roundToStylingColumnScale = (value: number): number =>
  Math.round(value * 10000) / 10000

export const editorCharacterStylingInputFromLayer = (
  layer: EditorCharacterStyleLayer,
): EditorCharacterStylingInput => {
  const input: EditorCharacterStylingInput = {}
  if (layer.fontFamily !== undefined) input.fontFamily = layer.fontFamily
  if (layer.fontSizePt !== undefined)
    input.fontSize = roundToStylingColumnScale(layer.fontSizePt)
  if (layer.fontWeight !== undefined)
    input.fontWeight = String(layer.fontWeight)
  if (layer.fontStyle !== undefined) input.fontStyle = layer.fontStyle
  if (layer.color !== undefined)
    input.color = editorColorSpecFromCss(layer.color)
  if (layer.textDecoration !== undefined)
    input.textDecoration = layer.textDecoration
  if (layer.textDecorationColor !== undefined)
    input.textDecorationColor = editorColorSpecFromCss(
      layer.textDecorationColor,
    )
  if (layer.letterSpacing !== undefined)
    input.letterSpacing = roundToStylingColumnScale(layer.letterSpacing)
  if (layer.textCase !== undefined) input.textCase = layer.textCase
  if (layer.textStrokeWidth !== undefined)
    input.textStrokeWidth = roundToStylingColumnScale(layer.textStrokeWidth)
  if (layer.textStrokeColor !== undefined)
    input.textStrokeColor = editorColorSpecFromCss(layer.textStrokeColor)
  if (layer.textFillColor !== undefined)
    input.textFillColor = editorColorSpecFromCss(layer.textFillColor)
  return input
}
